module.exports = __webpack_public_path__ + "static/media/opensans-light.28815c72.woff";